<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div>

  <div class="table-container">
    <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
      <div class="">
        <div class="search-container">
          <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
            [(ngModel)]="searchValue">
        </div>
      </div>

      <div class="">
        <div class="d-flex gap-2 action-buttons-container">
          <div *ngIf="documentData.saveButtonForDocument && type =='Tagging'"
            class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addTagFunc($event)"
            matTooltip="Add Tag" style="padding:1px 8px !important;">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReport('Excel')" style="padding:1px 8px !important;">
            <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReport('Pdf')" style="padding:1px 8px !important;">
            <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)" matTooltip="Audit Trail">
            <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          </div>
          <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="refreshGrid()"
            matTooltip="Refresh Grid">
            <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
            <span class="reload_text">Reload</span>
          </div>

        </div>
      </div>
    </div>

    <table class="dynamic-table-container documentTable">
      <th style="min-width: 60px; text-align: center;">
      </th>
      <th *ngFor="let column of columnList"
        [ngStyle]="{'min-width': 'column.width', 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
          <span>{{column.column}}</span>
          <div class="d-flex gap-2 align-items-center">
            <div>
              <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
            </div>
          </div>
        </div>
      </th>

      <th class="sticky-col first-col"></th>
      <!-- search input row is added -->
      <tr *ngFor="let tag of pagedItems | searchFilter : searchValue; let idx = index;">
        <td style="width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div [ngClass]="tag.childCheckBoxs ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div>
              <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                (change)="dataGridChildCheckBoxChecked($event, tag, idx)">
            </div>
          </div>
        </td>
        <td id="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'" *ngIf="type =='Tagging'"><span>{{tag.module}}</span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'" *ngIf="type =='Tagging'"><span>{{tag.taskId}}</span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'" *ngIf="type =='Tagging' && tag.module !='DOCS' && tag.module !='TRN'"><span>NA</span>
        </td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'" *ngIf="type =='Tagging' && tag.module =='DOCS' || tag.module =='TRN'">
          <span>{{tag.taskVersion}}</span>
        </td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'" *ngIf="type =='Tagged'"><span>{{tag.documentNo}}</span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{tag.status}}</span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'" *ngIf="type =='Tagging'"><span>{{tag.taskDetails}}</span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'"><span>{{tag.comments}}</span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{tag.createdOn | date:uiDateTimeFormat | uppercase}}</span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{tag.createdByUser}}</span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{tag.updatedOn | date:uiDateTimeFormat | uppercase}}</span></td>
        <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{tag.updatedByUser}}</span></td>
        <td class="sticky-col first-col" *ngIf="documentData.saveButtonForDocument && type=='Tagging'">
          <div class="action-icons">
            <i class="fa-solid fa-pencil" matTooltip="Edit" style="margin-left: 5px;"
              (click)="editTagFunc(tag,$event)"></i>
            <i class="fa-sharp fa-solid fa-trash" title="Delete" style="margin-left: 5px;"
              (click)="openDeletePopup(tag,$event)"></i>
            <i class="fa-solid fa-clipboard" *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail"
              style="margin-left: 5px;" (click)="openAuditTrail('individual',tag)"></i>
          </div>
        </td>
      </tr>
    </table>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>

  </div>
  <ng-template #addOrEditTagPopup>
    <div class="ng-template-container">
      <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
      </div>
      <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
          class="fa popupClose">&#xf00d;</i></button>
      <div mat-dialog-title>
        <label class="popupTitle"> {{title}}</label>
        <label class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
      </div>
      <div id="filed-container" class="form-continer" style="height: auto !important;">
        <div>
          <div class="row">
            <div class="col-md-6">
              <label for="email">Module</label><span class="mandatory-symbol">*</span>
              <div>
                <mat-select matInput placeholder="Select" id="module" [(ngModel)]="selectedModule"
                  (closed)="moduleSearchText=''" (click)="focusSearch('focus-module-search')">
                  <input type="search" id="focus-module-search" class="dropdownsearchstyle"
                    [(ngModel)]="moduleSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onModuleValueSelect($event,null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of moduleDropdown | assessmentSearch : moduleSearchText"
                    [value]="item.valueExp" (onSelectionChange)="onModuleValueSelect($event,item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <span id="module-required-msg">Please select module</span>
            </div>
            <div class="col-md-6">
              <div><label for="email ">Task</label><span class="mandatory-symbol">*</span></div>
              <div class="row-search-container">
                <input id="taskId" class="form-control" type="text" placeholder="Search" style="height: 30px;"
                  [(ngModel)]="documentTagData.taskId" (click)="searchTaskFunction()">
              </div>
              <span id="taskId-required-msg">Please search Task</span>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-12">
              <div><label for="email ">Comments</label></div>
              <textarea class="input-filed-textarea" rows="4" type="text"
                [(ngModel)]="documentTagData.comments"></textarea>
            </div>

          </div>
        </div>
        <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="addOrUpdateTag(documentTagData)" *ngIf="!visibleEditButton">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Add New</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="addOrUpdateTag(documentTagData)" *ngIf="visibleEditButton">
            <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
            <span class="reload_text text-white">Update</span>
          </div>
          <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
            <i class="fa fa-close"></i> Cancel
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #deleteTagPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <h2 mat-dialog-title>{{title }}</h2>
    <div style="margin: 15px 15px;">
      <div class="row">
        <div class="col-md-12">
          <div><label for="email">Reason for Delete</label><span style="color: red;">*</span></div>
          <textarea id="deleteReason" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="deleteReason"></textarea>
          <span id="deleteReason-required-msg">Please provide the reason for delete</span>
        </div>
      </div>
      <div class="button-continer" mat-dialog-actions class="btn-align">
        <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
          <i class="fa fa-trash"></i> Delete
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #searchTaskPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelTaskFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">Search Task</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container" class="form-continer">
      <div class="row">
        <div class="col-md-4">
          <label for="email">Task ID</label>
          <input type="text" class="input-filed-continers" [(ngModel)]="searchByTaskId">
        </div>
      </div>
      <div class="row text-center">
        <div class="group-dropdown-align">
          <div class="search-button-continer">
            <button mat-stroked-button class="searchButton searchButton1" (click)="seachTaskForDocumentsFunc()">
              <i class="fa-solid fa-magnifying-glass"></i> Search
            </button>
            <button mat-stroked-button class="cancelButton resetButton" (click)="gridResetFunction()">
              <i class="fa fa-repeat"></i> Reset
            </button>
          </div>
        </div>
      </div>
      <div class="table-container" *ngIf="isShowSearchedTaskGrid">
        <table class="search-manager-table-container">
          <th style="min-width: 80px; text-align: center;">

          </th>
          <th> <span>Parent Module</span> <span class="fa-solid fa-filter"></span> </th>
          <th> <span>Task ID</span> <span class="fa-solid fa-filter"></span> </th>
          <th *ngIf="selectedModuleValue == 'TRN' || selectedModuleValue == 'DOCS'"> <span>Version</span> <span
              class="fa-solid fa-filter"></span> </th>
          <th> <span>Status</span> <span class="fa-solid fa-filter"></span> </th>
          <th> <span>Task Details</span> <span class="fa-solid fa-filter"></span> </th>
          <th class="sticky-col first-col"></th>
          <tr class="data-row-container" *ngFor="let task of searchedTaskList; let idx = index;">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="task.searchTaskChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2;"
                    [checked]="task.searchTaskChildCheckBoxs"
                    (change)="searchTaskChildCheckBoxChecked($event, task, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ task.parentModule }}</td>
            <td class="row-data">{{ task.taskId }}</td>
            <td class="row-data" *ngIf="selectedModuleValue == 'TRN' || selectedModuleValue == 'DOCS'">{{ task.version
              }}</td>
            <td class="row-data">{{ task.status }}</td>
            <td class="row-data">{{ task.taskDetails }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="addButton" (click)="addTaskFunction()">
        <i class="fas fa-check"></i> Add
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelTaskFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>

  <app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
  <app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>